
import { create } from 'zustand';

interface WsState {
    timer?:NodeJS.Timeout;
    listeners:any;
    ws?:WebSocket;
    setWs: (ws:WebSocket) => void;
    setListeners: (data:any) => void;
    setTimer: (timer: NodeJS.Timeout) => void;
    clearTimer: () => void;
    deleteWs: () => void;
}
export const useWsState = create<WsState>((set) => ({
    timer: undefined,
    listeners: {},
    ws: undefined,
    setWs: (ws: WebSocket) => set((state) => ({ws: ws})),
    deleteWs: () => set((state) => {
        if (state.ws) state.ws.close();
        return ({ws: undefined})
    }),
    setTimer: (timer: NodeJS.Timeout) => set((state) => ({timer: timer})),
    setListeners: (data:any) => set((state) => ({listeners: data})),
    clearTimer: () => set((state) => {
        if (state.timer)
            clearInterval(state.timer)
        state.timer = undefined;
        return state;
    })
}));

export function useWs() {
    const setTimer = useWsState((state) => state.setTimer);
    const clearTimer = useWsState((state) => state.clearTimer);
    const listeners = useWsState((state) => state.listeners);
    const setListeners = useWsState((state) => state.setListeners);
    const setWs = useWsState((state) => state.setWs);
    const deleteWs = useWsState((state) => state.deleteWs);
    let ws = useWsState((state) => state.ws);

    async function connect() {
        return await new Promise((res, rej) => {
            clearTimer();
            console.log("try connect", process.env.REACT_APP_WS);
            const newWs = new WebSocket(process.env.REACT_APP_WS!);
            newWs.onopen = () => {
                console.log("onopen", process.env.REACT_APP_WS);
                if (listeners.connect)
                    listeners.connect.map((listener:any) => listener());
                res(newWs);
            }
            newWs.onerror = (err) => {
                console.error(err)
                if (newWs) {
                    newWs.close();
                    deleteWs();
                }
            };
            newWs.onclose = () => {
                if (listeners.disconnect)
                    listeners.disconnect.map((listener:any) => listener());
                setTimer(setTimeout(()=>connect(), 1000));
                if (ws) {
                    deleteWs();
                }
            }
            newWs.onmessage = (event) => {
                console.log("message", event.data);
                const message = JSON.parse(event.data);

                if (listeners[message.key])
                    listeners[message.key].map((listener:any) => listener(message.data));
            }
            ws = newWs;
            setWs(newWs);
        });
    }
    async function waitForConnection(callback:any) {
        if (!ws)
            await connect();
        if (ws?.readyState !== 1) {
            await new Promise((res, rej) => {
                let timer:any;
                timer = setInterval(() => {
                    if (ws?.readyState === 1)
                    {
                        clearInterval(timer);
                        res(1);
                    }
                }, 1000)
            })
        }
        return callback();
    }
    function on(key:string, callback:any) {
        waitForConnection(() => {
            if (!listeners[key])
                listeners[key] = []
            listeners[key].push(callback);
            setListeners(listeners);

            if (key === "connect") {
                if (ws?.readyState === 1)
                    listeners[key].map((listener:any) => listener());
            }
        });
    }
    function once(key:string, callback:any) {
        waitForConnection(() => {
            listeners[key] = [callback]
            setListeners(listeners);
        });
    }
    function emit(key:string, data:any = {}) {
        waitForConnection(() => {
            ws?.send(JSON.stringify({
                key,
                data
            }));
        });
    }
    function disconnect() {
        ws?.close();
    }

    return {on, once, emit, disconnect, state: ws?.readyState};
}